export const JOB_SATISFACTION_SUBMITTED_FLAG = "submitted";
